import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "../../../style/CounterpartyTicketview.css";
import * as ticketActions from "../../../modules/ticket/action";
import Loader from "../../Loader";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Modal from '@material-ui/core/Modal';
import { withStyles } from "@material-ui/core/styles";
import TicketPath from "../../../assets/images/ticket.png";
import { formatDate } from "../../../utils/DateFormatter";
import moment from "moment";
import { faArrowRight, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { green } from '@material-ui/core/colors';
import SummaryCard from "../../FormElement/SummaryCard";
import Grid from "@material-ui/core/Grid";
import CreateTable from "../../CreateTable";

import {
    faFileContract,
    faTicketAlt,
    faTractor,
    faUsers
  } from "@fortawesome/free-solid-svg-icons";
const styles = theme => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    paper: {
        position: 'absolute',
        width: 400,
        backgroundColor: "white",
        boxShadow: "1px",
        padding: "20px",
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '16px'
    },
    exapansionPanel: {
        backgroundColor: '#00bc84',
        color: 'white',
        marginTop: '15px'
    }
});

const CounterpartyDashboardview = (props) => {
    const { classes } = props;
    const { CounterPartyTicketList, counterPartyTicketData, counterPartyDashboard, loader, ticketDataLoader, dashboardDataLoader, groupByValue, previousDaysvalue, pageData, lastdaylength } = props;
    const [selectedHarvestYear, setSelectedHarvestYear] = useState(2019);
    const [pageNo, setPageNo] = useState(0);
    const [totalCount, setTotalCount] = useState(5);
    const [expandePanel, setexpandePanel] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [farmId, setFarmId] = useState(4);
    const [ele, setEle] = useState({});
    const [headerRows,setHeaderRows] = useState({
        truckLine: "Truckline",
        ticketNumber: "Ticket Number",
        createdAt: "Created Date",
        status: "Status",
        harvestYear: "Harvest Year",
        connectAction:"Action"
      })
    const [order,setOrder] = useState('desc')
    const [orderBy, setOrderBy] = useState('id') 

    useEffect(() => {
        props.actions.setPreviousDaysAction(previousDaysvalue || 7)
        props.actions.getCounterPartyDashboard(previousDaysvalue|| 7);
        props.actions.getCounterPartyDashboardbyoneday()
    }, []);
    useEffect(() => {
        props.actions.getCounterPartyDashboard(previousDaysvalue|| 7)
    }, [previousDaysvalue])
    const handleExapnaionPanel = (name) => (event, expanded) => {
        setexpandePanel(expanded ? name : false)
    }
    const handleSortRequest = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
      };
    
      const sortData = (array, order, orderBy) => {
        return array.sort((a, b) => {
          if (b[orderBy] < a[orderBy]) {
            return order === 'asc' ? -1 : 1;
          }
          if (b[orderBy] > a[orderBy]) {
            return order === 'asc' ? 1 : -1;
          }
          return 0;
        });
      };
    
      const sortedData = sortData([...counterPartyDashboard], order, orderBy);
      
    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleOpenModal = (value) => {
        setEle(value);
        setOpenModal(true);
    };

    function getModalStyle() {
        const top = 50;
        const left = 50;

        return {
            top: `${top}%`,
            left: `${left}%`,
            transform: `translate(-${top}%, -${left}%)`,
        };
    }





    const TableDropdown = ({ type, dropdownlabel, value, dropclass, farmId }) => {
        const handlerChange = (event) => {
            if (type === "harvest") {
                setSelectedHarvestYear(event.target.value);
                props.actions.getTicketsForCounterParty(farmId, event.target.value, totalCount, pageNo, groupByValue, previousDaysvalue);
            } else if (type === "pageNo") {
                setPageNo(event.target.value);
                props.actions.getTicketsForCounterParty(farmId, selectedHarvestYear, totalCount, event.target.value, groupByValue, previousDaysvalue);
            } else if (type === "totalCount") {
                setTotalCount(event.target.value);
                props.actions.getTicketsForCounterParty(farmId, selectedHarvestYear, event.target.value, pageNo, groupByValue, previousDaysvalue);
            }
        };
        return <div className={dropclass} onClick={(e) => e.stopPropagation()}>
            <label> {dropdownlabel}</label>
            <Select className='select' value={type === "harvest" ? selectedHarvestYear : type === "pageNo" ? pageNo : totalCount} onChange={handlerChange}>
                {value && value.map((ele) => (
                    <MenuItem key={ele} value={ele}>
                        {ele}
                    </MenuItem>
                ))}
            </Select>
        </div>
    }


    const Pagination = ({ current, prev, next, total }) => {

        return <div className='dropdown-container'>

            <label className="pageNo"> {current + 1} - {total} of {total}</label>
            <span className="Arrows" onClick={() => props.actions.getTicketsForCounterParty(farmId, selectedHarvestYear, totalCount, current - 1, groupByValue, previousDaysvalue)}>

                {!prev && <FontAwesomeIcon icon={faArrowLeft} style={{ fontSize: "16px" }} />}
            </span>
            <span className="Arrows" onClick={() => props.actions.getTicketsForCounterParty(farmId, selectedHarvestYear, totalCount, current + 1, groupByValue, previousDaysvalue)}>
                {!next && <FontAwesomeIcon icon={faArrowRight} style={{ fontSize: "16px" }} />}
            </span>

        </div>
    }

    const convertorder = (row,groupValue) => {
        let tempRows = headerRows
        tempRows['firstRow'] = groupByValue
        // setHeaderRows({...tempRows})
        console.log(groupValue,'groupvalue')
        let temp = row;
        for (let i = 0; i < temp.length; i++) {
            console.log(temp[i].truckline.name,groupValue,"Truckline",groupValue === "Commodity",groupValue === "Truckline"?temp[i].truckline.name:groupValue === "Commodity"?temp[i].commodityResponseDTO.name:temp[i].destinationResponseDTO.name,'checkingggg')
            temp[i]['firstRow'] = <div className='tcketNumber'>
          {groupValue === "Truckline"?temp[i].truckline.name:groupValue === "Commodity"?temp[i].commodityResponseDTO.name:temp[i].destinationResponseDTO.name}
          </div>
          temp[i]['createdAt']= moment(new Date(temp[i].createdAt)).format("lll")
          
        //   temp[i]['updatedAt']= moment(new Date(temp[i].addressEntity.updatedAt)).format("lll")
        //   temp[i]['updatedBy']=  temp[i].addressEntity.updatedBy
        //   temp[i]['acceptAction'] = <button className="send-Request" onClick={()=>this.handleOpenDealog(temp[i].senderId,temp[i].senderFarmName,false)}> Take action</button>
        //   temp[i]['connectAction'] =  <button className="send-Request" onClick={()=>this.handleOpenDealog(temp[i].senderId,temp[i].senderFarmName,true)}> Take action</button>
        //   temp[i]['connectAction'] = "connect"
        }
        return temp;
      }
    if (loader) {
        return <Loader />;
    }
    return (
        <div className="root">
             <div className="Refresh" onClick={()=>{

props.actions.getCounterPartyTicketList("Truckline");
props.actions.getCounterPartyDashboard(previousDaysvalue|| 7);
props.actions.getCounterPartyDashboardbyoneday()


      }}><img width={26} src="https://img.icons8.com/?size=100&id=35635&format=png&color=40C057" alt="Refresh"/></div>
            <Modal
                open={openModal}
                onClose={handleCloseModal}
            >
                <div style={getModalStyle()} className={classes.paper}>
                    <div className="modal-header">
                    <h2 id="simple-modal-title">Ticket Details:</h2>
                                        <span style={{cursor:"pointer"}}  onClick={()=>handleCloseModal()}> ❌ </span>
                                        </div>
                    <p id="simple-modal-description">
                        Ticket Number : <span> {ele.ticketNumber}</span> <br />
                        Origin Type :  <span>{ele.originType && ele.originType.type}</span> <br />
                        Load Date : <span>{moment(new Date(ele.loadDate)).format("lll")}</span>  <br />
                        Load Number Indicator: <span>{ele.loadNumber}</span> <br />
                        Commodity : <span>{ele.commodityResponseDTO && ele.commodityResponseDTO.name}</span> <br />
                        Delivery Destination : <span>{ele.destinationResponseDTO && ele.destinationResponseDTO.name}</span> <br />
                        Driver Name : <span>{ele.driverName}</span> <br />
                        Scale Shrink Bushels : <span>{ele.estimatedHomeScaleShrinkBushels}</span> <br />
                        Estimated Load Bushels : <span>{ele.fieldEstimatedLoadBushels}</span> <br />
                        Estimated Load Weight : <span>{ele.fieldEstimatedLoadWeight}</span> <br />
                    </p>

                </div>
            </Modal>
                <div className='MainContainer'>
                <div className='Stikers'>
                  <SummaryCard
                    calculatedNumber={lastdaylength? lastdaylength.length:0}
                    message={"No of new tickets in last 24 hrs"}
                    icon={faTicketAlt}
                  />
                  {/* <SummaryCard
                    calculatedNumber={counterPartyDashboard.length}
                    message={"Farm(s) Created"}
                    icon={faTractor}
                  />
                  <SummaryCard
                    calculatedNumber={counterPartyDashboard.length}
                    message={"Harvest Contract(s) Created"}
                    icon={faFileContract}
                  />
                  <SummaryCard
                    calculatedNumber={counterPartyDashboard.length}
                    message={"Harvest Ticket(s) Created"}
                    icon={faTicketAlt}
                  /> */}
                </div>
                    <div className="tableContainer">
                        {dashboardDataLoader ? <div className='tableLoader'><Loader /></div> : <React.Fragment>
                            {counterPartyDashboard && counterPartyDashboard.length > 0 ? <div className='Table-container'>
                                <table className="custom-table">
                                    <tr>
                    {groupByValue === "Truckline"? 
                    <th style={{cursor:'pointer'}} onClick={() => handleSortRequest("truckLine")}>Truckline {orderBy === "truckLine" ? (order === 'asc' ? '⬆' : '⬇') : ''}</th>:
                    groupByValue === "Commodity" ? <th style={{cursor:'pointer'}} onClick={() => handleSortRequest("commodity")}>Commodity {orderBy === "commodity" ? (order === 'asc' ? '⬆' : '⬇') : ''}</th>:
                    <th style={{cursor:'pointer'}} onClick={() => handleSortRequest("destination")}>External Destination {orderBy === "destination" ? (order === 'asc' ? '⬆' : '⬇') : ''}</th>
                    }
                    <th style={{cursor:'pointer'}} onClick={() => handleSortRequest('ticketNumber')}>Ticket Number {orderBy === 'ticketNumber' ? (order === 'asc' ? '⬆' : '⬇') : ''}</th>
                    <th style={{cursor:'pointer'}} onClick={() => handleSortRequest('createdAt')}>Created Date {orderBy === 'createdAt' ? (order === 'asc' ? '⬆' : '⬇') : ''}</th>
                    <th style={{cursor:'pointer'}} onClick={() => handleSortRequest('status')}>Status {orderBy === 'status' ? (order === 'asc' ? '⬆' : '↓') : ''}</th>
                    <th style={{cursor:'pointer'}} onClick={() => handleSortRequest('harvestYear')}>Harvest Year {orderBy === 'harvestYear' ? (order === 'asc' ? '⬆' : '⬇') : ''}</th>
                    <th>Actions</th>
                  </tr>
                                    {sortedData &&
                                        sortedData.map(ele =>
                                            <tr key={ele.id} className='hover'>
                                                <td >
                                                    <div className='tcketNumber'>
                                                    {groupByValue === "Truckline"?ele.truckline.name:groupByValue === "Commodity"?ele.commodityResponseDTO.name:ele.destinationResponseDTO.name}
                                                    {/* {ele.truckline.name} */}
                                                    </div>
                                                    </td>
                                                <td>
                                                    <div className='tcketNumber'>{ele.ticketNumber}</div>

                                                </td>
                                                <td>{moment(new Date(ele.createdAt)).format("lll")}</td>
                                                <td>{ele.status}</td>
                                                {/* <td>{ele.originType && ele.originType.type}</td> */}
                                                {/* <td>{ele.loadDate}</td> */}
                                                {/* <td>{ele.destinationResponseDTO && ele.destinationResponseDTO.name}</td> */}
                                                <td>{ele.commodityResponseDTO && ele.harvestYear}</td>
                                                {/* <td>{ele.truckline && ele.truckline.name}</td> */}
                                                <td>
                                                    <img alt="ticket" width={20} src={TicketPath} onClick={() => handleOpenModal(ele)} />
                                                </td>
                                            </tr>
                                        )}
                                </table>
                                <br />
                                <br />
                                {/* <CreateTable
                order={order}
                orderBy={orderBy}
                headerRows={headerRows}
                rowData={convertorder(counterPartyDashboard,groupByValue)}
                delete={this.deleteRow}
                // location={`${prevPath}${currentPage}/edit`}
                edit={this.editRow}
                onRequestSort={this.handleRequestSort}
                isMenuRequired={false}
              /> */}

                                {/* <div className='page-container'>
                                    {pageData && <Pagination current={pageData.number} total={pageData.totalPages} prev={pageData.first} next={pageData.last} />}
                                    <TableDropdown type="totalCount" dropdownlabel="Records Per Page" value={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]} dropclass={"dropdown-container"} farmId={farm.id} />
                                </div> */}
                            </div> :
                                <div className='Nodata-container'>
                                    {`No Data Available`}
                                </div>}
                        </React.Fragment>}
                    </div>
                </div>
        </div>
    );

}

function mapStateToProps(state, props) {
    return {
        CounterPartyTicketList: state.ticketReducer.CounterPartyTicketList,
        fetchingComplete: state.ticketReducer.fetchingComplete,

        pageCount: state.ticketReducer.pageCount,
        totalElements: state.ticketReducer.totalElements,
        ErrorMessage: state.globalserverMessage.ErrorMessage,
        SubFarmId: state.FarmManagementReducer.SubFarmId,
        MainFarmId: state.FarmManagementReducer.MainFarmId,
        selectedYear: state.harvestYearReducer.selectedYear,
        PrefencesList: state.preferencesReducer.PrefencesList,
        searchTerm: state.ticketReducer.searchTerm,
        counterPartyTicketData: state.ticketReducer.counterPartyTicketData,
        loader: state.ticketReducer.loader,
        ticketDataLoader: state.ticketReducer.ticketDataLoader,
        groupByValue: state.ticketReducer.groupByValue,
        previousDaysvalue: state.ticketReducer.previousDaysvalue,
        pageData: state.ticketReducer.pageData,
        counterPartyDashboard: state.ticketReducer.counterPartyDashboard,
        dashboardDataLoader: state.ticketReducer.dashboardDataLoader,
        lastdaylength: state.ticketReducer.lastdaylength
    };
}
function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            {
                ...ticketActions,
            },
            dispatch
        )
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CounterpartyDashboardview));



// WEBPACK FOOTER //
// ./src/components/private/Tickets/CounterpartyDashboard.js